export default "__VITE_ASSET__c50725df__"